import { PERMISSIONS } from '@helios/authz';
import { useScopedOperationalMutation, useScopedOperationalQuery } from '@/hooks/useScopedOperationalQuery';
import { observabilityApi } from './observability.api';

export function useObservabilityCommandCenter() {
  return useScopedOperationalQuery('observability', PERMISSIONS.PLATFORM_ADMIN, observabilityApi.getDashboard, 15_000);
}
export function useRunPerformancePass() {
  return useScopedOperationalMutation('observability', PERMISSIONS.PLATFORM_ADMIN, (_input: void, options) => observabilityApi.runPerformancePass(undefined, options));
}
